'use client';

import { createContext, type PropsWithChildren, useContext } from 'react';
import type { CtaType } from '@repo/segment/Analytics/types';
import type { AnalyticsType } from '@repo/segment/types';

interface ProductCardBottomLineContextValue {
  isWithinProductCardBottomLine: boolean;
  ctaData?: { cta: CtaType; ctaAnalytics: AnalyticsType };
}

type ProductCardBottomLineContextProps = PropsWithChildren<ProductCardBottomLineContextValue>;

const defaultContextValue: ProductCardBottomLineContextValue = {
  isWithinProductCardBottomLine: false,
  ctaData: undefined,
};

export const ProductCardBottomLineContext =
  createContext<ProductCardBottomLineContextValue>(defaultContextValue);

export const ProductCardBottomLineContextProvider = ({
  children,
  isWithinProductCardBottomLine,
  ctaData,
}: ProductCardBottomLineContextProps) => {
  return (
    <ProductCardBottomLineContext.Provider value={{ isWithinProductCardBottomLine, ctaData }}>
      {children}
    </ProductCardBottomLineContext.Provider>
  );
};

export function useProductCardBottomLineContext() {
  const context = useContext(ProductCardBottomLineContext);
  if (!context) {
    return defaultContextValue;
  }

  return context;
}
